import { Button } from 'components/common';
import { noop } from 'libs';
import Loader from './Loader';

interface LoadingProps {
  error?: boolean;
  pastDelay: boolean;
  retry?: () => void;
}

const Loading = ({ error = false, pastDelay, retry = noop }: LoadingProps) => {
  if (error) {
    return (
      <div>
        <span className="me-2">Error!</span>
        <Button onClick={retry} variant="primary-dark">
          Retry
        </Button>
      </div>
    );
  }

  if (pastDelay) {
    return <Loader isLoading />;
  }

  return null;
};

export default Loading;
